import classNames from 'classnames';

export const getButtonClassName = ({ isDisabled }: { isDisabled: boolean }) =>
  classNames(
    'bg-white',
    'rounded-md',
    'border',
    'border-gray-300',
    'px-3',
    'py-2',
    'w-full',
    'inline-flex',
    'justify-between',
    'items-center',
    {
      'bg-opacity-25': isDisabled,
      'cursor-default': !isDisabled,
      'cursor-not-allowed': isDisabled,
      'text-gray-400': isDisabled,
    },
  );
